// import LocalStorage from "local-storage-json"
import Random from "@fae/source/utility/Random.js"
const random = new Random()

// TODO: ubuild this out further! i had to stub out the node module since it wasn't play well with Node
const LocalStorage = {
    "get": function() {},
    "set": function() {},
}

// https://frog-tactics.s3-us-west-2.amazonaws.com/assets/music/overworld.wav

import App from "@fae/source/models/App.js"
import audioTriggers from "@fae/source/data/audios.js"

const audiomix = new class Audiomix {
    constructor() {
        this.userSoundVolume = LocalStorage.get("sound-volume") ?? 1
        this.userMusicVolume = LocalStorage.get("music-volume") ?? 1
        this.userAmbienceVolume = LocalStorage.get("ambience-volume") ?? 1

        this.hasInteracted = false
        document.addEventListener("click", () => {
            if(this.hasInteracted == false) {
                this.hasInteracted = true

                if(this.untriggeredRequests != undefined) {
                    this.untriggeredRequests.forEach((audio) => {
                        this.trigger(audio)
                    })
                }
            }
        })

        window.audiomix = this
    }
    getTrigger(triggerKey) {
        if(App.game?.audio != undefined
        && App.game.audio[triggerKey] != undefined) {
            return App.game.audio[triggerKey]
        }
        return audioTriggers[triggerKey]
    }
    getAllTriggers() {
        return Object.values(audioTriggers).concat(Object.values(App.game?.audio || []))
    }
    trigger(request) {
        if(isString(request)) {
            request = {"key": request}
        }

        if(this.hasInteracted == false) {
            this.untriggeredRequests = this.untriggeredRequests || []
            this.untriggeredRequests.push(request)
            return
        }

        const trigger = this.getTrigger(request.key)

        if(trigger == undefined) {
            // console.log("Could not find audio trigger:", request)
            return
        }

        if(trigger.kill != undefined) {
            this.kill(trigger.kill)
        }

        if(trigger.audio == undefined) return
        trigger.audio = arrayify(trigger.audio)
        if(trigger.audio.length == 0) return

        if(trigger.type == "sequence:loop") {
            setupSequenceTrigger(trigger)
            playAudio(trigger.audio[0], trigger)
        } else if(trigger.type == "sequence:march") {
            setupSequenceTrigger(trigger)
            playAudio(trigger.audio[0], trigger)
        } else if(trigger.type == "simultaneously") {
            trigger.audio.forEach((sound) => playAudio(sound, trigger))
        } else if(trigger.type == "once:rotation") {
            playAudio(trigger.audio[0], trigger)
            trigger.audio.push(trigger.audio.shift())
        } else if(trigger.type == "once:randomly") {
            playAudio(random.element(trigger.audio), trigger)
        } else {
            playAudio(trigger.audio[0], trigger)
        }

        if(trigger.hasIntensity == true
        && request.intensity != undefined) {
            trigger.audio.forEach((audio, index) => {
                if(index > request.intensity) {
                    audio.volume = 0
                }
            })
        }
    }
    setSoundVolume(volume) {
        this.userSoundVolume = volume
        LocalStorage.set("sound-volume", volume)
    }
    get musicVolume() {
        return this.userMusicVolume
    }
    update(delta) {
        // if(this.music !== undefined) {
        //     this.music.volume -= (this.music.volume - this.musicVolume) / 25
        //     if(Math.abs(this.music.volume - this.musicVolume) < 0.001) {
        //         this.music.volume = this.musicVolume
        //     }
        // }
        this.getAllTriggers().forEach((trigger) => {
            if(trigger.func instanceof Function) {
                trigger.func(App.getActiveStage())
            }
        })
    }
    kill(kill) {
        if(kill.key != undefined) {
            kill.key = arrayify(kill.key)
            kill.key.forEach((key) => {
                const trigger = getTrigger(key)
                if(trigger != undefined) {
                    trigger.audio = arrayify(trigger.audio)
                    trigger.audio.forEach((audio) => audio && audio.pause())
                }
            })
        }
        if(kill.label != undefined) {
            kill.label = arrayify(kill.label)
            kill.label.forEach((label) => {
                this.getAllTriggers().forEach((trigger) => {
                    trigger.label = arrayify(trigger.label)
                    if(trigger.label.includes(label)) {
                        trigger.audio = arrayify(trigger.audio)
                        trigger.audio.forEach((audio) => audio && audio.pause())
                    }
                })
            })
        }
    }
    killall() {
        this.getAllTriggers().forEach((trigger) => {
            trigger.audio = arrayify(trigger.audio)
            trigger.audio.forEach((audio) => audio && audio.stop())
        })
    }
    getActiveTriggerByLabel(label) {
        return this.getAllTriggers().find((trigger) => {
            trigger.label = arrayify(trigger.label)
            trigger.audio = arrayify(trigger.audio)
            return (trigger.label?.includes(label) || trigger.label == label)
                && trigger.audio.find((audio) => audio.paused != true && audio.paused != undefined) != undefined
        })
    }
}

const MASTER_VOLUME = 0.5

function playAudio(sound, {volume = 1, loop = false, type = "", label}) {
    if(sound == undefined) return

    if(label == "music") {
        volume *= audiomix.userMusicVolume
    } else if(label == "ambience") {
        volume *= audiomix.userAmbienceVolume
    } else {
        volume *= audiomix.userSoundVolume
    }

    sound.pause()
    sound.loop = loop
    sound.volume = volume * MASTER_VOLUME
    sound.currentTime = 0
    sound.play()
}

function setupSequenceTrigger(trigger) {
    if(trigger == undefined) return
    if(trigger.hasBeenSetup == true) return
    trigger.hasBeenSetup = true

    const firstAudio = trigger.audio[0]

    trigger.audio.forEach((audio, index) => {
        const currentAudio = trigger.audio[index]
        const nextAudio = trigger.audio[index + 1]

        currentAudio.addEventListener("ended", () => {
            if(nextAudio != undefined) {
                playAudio(nextAudio, trigger)
            } else {
                if(trigger.type == "sequence:march") {
                    playAudio(currentAudio, trigger)
                }
                if(trigger.type == "sequence:loop") {
                    playAudio(firstAudio, trigger)
                }
            }
        })
    })
}

function arrayify(array) {
    return array instanceof Array ? array : [array]
}

function isString(value) {
    return typeof value === "string" || value instanceof String
}


// this.musicPlaying = LocalStorage.get("musicPlaying")
// if(this.musicPlaying == undefined) {
//     this.musicPlaying = {"track": "debris", "time": Date.now()}
//     LocalStorage.set("musicPlaying", this.musicPlaying)
// }
// this.music = music[name]
// this.music.volume = this.musicVolume
// this.music.currentTime = params.currentTime || 0
// this.music.loop = params.loop || false
// this.music.play()
// // this.music.volume = this.musicVolume * this.devMusicVolume
// // if(__STAGE__ === "DEVELOPMENT") {
// //     this.music.currentTime = (Date.now() - this.musicPlaying.time) / 1000
// // }
// // this.music.addEventListener("ended", () => {
// //     LocalStorage.set("musicPlaying", {
// //         "time": Date.now(),
// //         "track": "debris"
// //     })
// //     this.music.currentTime = 0
// //     this.music.play()
// // })

export default audiomix

window.fae = window.fae || {}
window.fae.audiomix = audiomix
